/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgLightning = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.31362 0.666885C7.26751 -0.57538 9.37144 0.0186111 9.37144 1.68867L9.37144 4.85628L13.7161 4.85628C15.0675 4.85628 15.9407 6.39532 15.0894 7.54125L9.70193 15.3132L9.6865 15.3333C8.73261 16.5756 6.62869 15.9816 6.62869 14.3115V11.1439H2.28401C0.932633 11.1439 0.0594528 9.60486 0.910706 8.45893L6.2982 0.68697L6.31362 0.666885ZM7.29144 1.68917C7.29144 1.68934 7.29144 1.689 7.29144 1.68917V1.68917ZM7.29144 2.90516V6.93628L12.9779 6.93628L8.70869 13.095V9.0639H3.02222L7.29144 2.90516ZM13.7161 6.93628C13.7163 6.93628 13.716 6.93628 13.7161 6.93628V6.93628Z'
      fill='currentColor'
    />
  </svg>
)
export default SvgLightning
